import { render, staticRenderFns } from "./work-header.vue?vue&type=template&id=539912d8&scoped=true"
import script from "./work-header.vue?vue&type=script&lang=ts"
export * from "./work-header.vue?vue&type=script&lang=ts"
import style0 from "./work-header.vue?vue&type=style&index=0&id=539912d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539912d8",
  null
  
)

export default component.exports